module.exports = __webpack_public_path__ + "public/img/Perencanaan Iklan Media Sosial untuk Manajer Periklanan.ebf76bea.png";